import { oliveItemTokens } from '@ds/tokens'

const tokens = {
  activeBackgroundColor: oliveItemTokens.itemBgColorActive,
  hoverBackgroundColor: oliveItemTokens.itemBgColorHover,
  selectedBackgroundColor: oliveItemTokens.itemBgColorSelected,
} as const

export default tokens
